import text from 'fukku/styles/texts.module.scss'

type DiscountProps = {
	discountText: string | undefined
}

export const Discount = ({ discountText }: DiscountProps) => {
	return <span className={text.uppercaseS}>{discountText}</span>
}
